import { redirect, type AnyRoute } from '@tanstack/react-router'

import { isTRPCClientError } from '@/utils/trpc'

const safeLoader = (route: AnyRoute, loaderFn?: (...args: any[]) => any) => {
    if (!loaderFn) return undefined

    return (async (...args: any[]) => {
        try {
            return await loaderFn(...args)
        } catch (err) {
            let cause = err
            if (isTRPCClientError(err)) {
                cause = err.cause
            }
            if (cause instanceof DOMException && cause.name === 'AbortError') {
                throw redirect({ to: route.to })
            }
            throw err
        }
    }) as typeof loaderFn
}

/**
 * This is a workaround to avoid the loader function from throwing an error when the user navigates away from the page to fix tanstack router's abort error handling bug.
 * @param route - The route whose loader should be wrapped.
 */
export const applySafeLoader = (route: AnyRoute) => {
    if (route.options?.loader) {
        route.options.loader = safeLoader(route, route.options.loader)
    }
    if (Array.isArray(route.children) && route.children.length > 0) {
        route.children.forEach((child: AnyRoute) => applySafeLoader(child))
    }
}
